import type { Dayjs, ConfigType } from 'dayjs';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export const localizeTime = (config: ConfigType, format?: string): Dayjs => {
    return dayjs.utc(config, format).local();
};
